import { render, staticRenderFns } from "./RiskAnalysisComponent.vue?vue&type=template&id=584a9434&scoped=true"
import script from "./RiskAnalysisComponent.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisComponent.vue?vue&type=script&lang=js"
import style0 from "./RiskAnalysisComponent.vue?vue&type=style&index=0&id=584a9434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a9434",
  null
  
)

export default component.exports